import { PureComponent } from 'react'
import classNames from 'classnames'
import styles from './index.module.scss'

export default class Misic extends PureComponent {
  state = {
    musicPlay: true
  }

  musicTrans = (play) => {
    this.setState({
      musicPlay: play
    })
  }

  handleClick = (play) => {
    this.props.clickHandle(play);
    this.musicTrans(play)
  }

  render () {
    const { color } = this.props
    const { musicPlay } = this.state
    return (
      <div>
        {musicPlay && (
          <div
            onClick={() => this.handleClick(false)}
            className={classNames(styles.wrap, {
              [styles.blue]: color === 'blue'
            })}>
              <ul className={styles.music}>
                <li className={styles.m1}></li>
                <li className={styles.m2}></li>
                <li className={styles.m3}></li>
                <li className={styles.m2}></li>
                <li className={styles.m1}></li>
                <li className={styles.m3}></li>
              </ul>
            </div>
        )}
        {!musicPlay && (
          <div
            onClick={() => this.handleClick(true)}
            className={classNames(styles.wrap, styles.collapse, {
              [styles.blue]: color === 'blue'
            })}>
              <ul className={styles.music}>
                <li className={styles.m4}></li>
                <li className={styles.m4}></li>
                <li className={styles.m4}></li>
                <li className={styles.m4}></li>
                <li className={styles.m4}></li>
                <li className={styles.m4}></li>
              </ul>
            </div>
        )}
        </div>

    )
  }
}
